// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .u2021-eula-dialog {
  height: 95%;
}

::ng-deep .u2021-eula-content {
  height: 98%;
}

:host .modal-body {
  height: calc(100% - 70px);
  padding: 0;
}
:host .modal-body.ios-overflow {
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/U2021_eula/U2021_eula-modal/U2021_eula-modal.component.scss"],"names":[],"mappings":"AAIA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAOI;EACI,yBAAA;EACA,UAAA;AAJR;AAMQ;EACI,cAAA;AAJZ","sourcesContent":["\n@import \"../../U2000_style/U2000_style-mixins\";\n@import \"../../U2000_style/U2000_style-variables\";\n\n::ng-deep .u2021-eula-dialog {\n    height:95%;\n}\n\n::ng-deep .u2021-eula-content {\n    height:98%;\n}\n\n:host {\n    .modal-body {\n        height: calc(100% - 70px);\n        padding: 0;\n\n        &.ios-overflow {\n            overflow: auto;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
